// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fkGp","top":"styles_top__39_o3","left":"styles_left__1bK1X","description":"styles_description__1Ue-E"};